export const extractGoogleMapsUrl = (address?: string | null): string | undefined => {
  if (!address) return undefined;

  const explicitMatch = address.match(/\((https?:\/\/[^)\s]+)\)/i);
  if (explicitMatch?.[1]) {
    return explicitMatch[1];
  }

  const encodedQuery = encodeURIComponent(address.trim());
  return `https://www.google.com/maps/search/?api=1&query=${encodedQuery}`;
};

export const buildShareText = ({
  gor,
  bookingInfo,
  currentDateLabel,
  pricing,
}: {
  gor: {
    nama: string;
    jam?: string | null;
    biaya?: string | null;
    kapasitasMaksimal?: number;
    alamat?: string | null;
    id?: string;
  };
  bookingInfo: {
    tanggal: string | null;
    jumlahWaitinglist?: number;
    daftarWaitinglist?: string[];
    waitinglistByLevel?: Record<string, string[]>;
    kapasitasMaksimal?: number;
    pemainByLevel?: Record<string, string[]>;
  };
  currentDateLabel?: string;
  pricing?: { normalPrice: number; finalPrice: number; discountAmount: number } | null;
}) => {
  if (!gor || !bookingInfo.tanggal) return '';

  const mapsUrl = extractGoogleMapsUrl(gor.alamat);
  const paidCount = Object.values(bookingInfo.pemainByLevel || {}).reduce((sum, list) => sum + (list?.length || 0), 0);
  const waitingCount = bookingInfo.jumlahWaitinglist ?? bookingInfo.daftarWaitinglist?.length ?? 0;
  const shareTotal = paidCount + waitingCount;
  const capacity = bookingInfo.kapasitasMaksimal ?? gor.kapasitasMaksimal ?? 0;

  let shareText = `🏸 *Info Mabar Badminton RaketerS*\n\n`;
  shareText += `*${gor.nama}*\n`;
  shareText += `📅 ${currentDateLabel || 'Hari ini'}, ${bookingInfo.tanggal}\n`;

  if (gor.jam && gor.jam !== '-') {
    shareText += `⏰ Jam Main: ${gor.jam}\n`;
  }
  if (gor.biaya && gor.biaya !== '-') {
    const normalPrice = pricing?.normalPrice ?? parseInt(gor.biaya);
    const finalPrice = pricing?.finalPrice ?? normalPrice;
    if (pricing && pricing.discountAmount > 0) {
      shareText += `💰 Biaya: ~Rp${normalPrice.toLocaleString('id-ID')}~ → *Rp${finalPrice.toLocaleString('id-ID')}* (diskon early booking)\n`;
    } else {
      shareText += `💰 Biaya: Rp${normalPrice.toLocaleString('id-ID')}\n`;
    }
  }
  if (mapsUrl) {
    shareText += `📍 Google Maps: ${mapsUrl}\n`;
  }

  const gorId = gor.id;
  if (gorId) {
    const gorUrl = `${typeof window !== 'undefined' ? window.location.origin : 'https://bookingmabar.com'}/gor/${gorId}`;
    shareText += `\nDaftar: 🔗 ${gorUrl}\n\n`;
  }

  shareText += `👥 *Daftar Pemain* (${shareTotal}/${capacity})\n`;
  shareText += `✅ *Pemain utama sudah pasti berhak mengikuti mabar (sudah bayar)*\n\n`;

  Object.entries(bookingInfo.pemainByLevel || {}).forEach(([level, pemainList]) => {
    if (pemainList.length > 0) {
      shareText += `*Level ${level}* (${pemainList.length} pemain):\n`;
      pemainList.forEach((nama, idx) => {
        shareText += `${idx + 1}. ${nama}\n`;
      });
      shareText += `\n`;
    }
  });

  if (waitingCount > 0) {
    shareText += `⏳ *Reservasi (Menunggu Pembayaran)* (${waitingCount} pemain):\n`;
    shareText += `💡 *Catatan:* Pemain reservasi masih berhak mengikuti mabar jika ada slot kosong.\n\n`;
    Object.entries(bookingInfo.waitinglistByLevel || {}).forEach(([level, pemainList]) => {
      if (pemainList.length > 0) {
        shareText += `*Level ${level}* (${pemainList.length} pemain):\n`;
        pemainList.forEach((nama, idx) => {
          shareText += `${idx + 1}. ${nama}\n`;
        });
        shareText += `\n`;
      }
    });
  }

  return shareText;
};
